import { VariableType } from '@/proto/common';

/** Synthetic node ID for system-provided variables (matches backend SYSTEM_NODE_ID). */
export const SYSTEM_NODE_ID = 'system';

export interface SystemVariableDesc {
  name: string;
  displayName: string;
  type: VariableType;
  exampleString?: string;
}

/**
 * Always-available variables not tied to any node. Names must match
 * the backend constants in variable_utils.py.
 */
export const SYSTEM_VARIABLE_CATALOG: SystemVariableDesc[] = [
  {
    name: 'now',
    displayName: 'Current Time',
    type: VariableType.DATE_TIME,
    exampleString: 'Jul 4, 3:45 PM',
  },
];

/**
 * Returns the system variable descriptor for a given variable name,
 * or undefined if the name isn't a known system variable.
 */
export function getSystemVariable(
  name: string
): SystemVariableDesc | undefined {
  return SYSTEM_VARIABLE_CATALOG.find((v) => v.name === name);
}
